import { IDataProvider } from "@/store";

export interface ILog {
  type: string;
  status: string;
  userInfo: string;
  userPublicId?: string | null;
  message: string;
}

export interface ILogsState {
  log: ILog | null;
  logs: ILog[] | null;
  dataProvider: IDataProvider<ILog>;
}

export const state: ILogsState = {
  log: null,
  logs: null,
  dataProvider: {
    items: [],
    pager: {
      buttonsToShow: 3,
      currentPage: 1,
      endPage: 1,
      startPage: 1,
      totalPages: 1,
    },
  },
};
